<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <button
      mat-icon-button
      class="modal-close-button"
      type="button"
      (click)="onEventClose()"
      aria-label="Close"
      matRipple="false">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="modal-form">
      <p class="modal-subtitle s1_400">
        <span>{{ 'tenant.passwordManagement.instructionText' | translate }}&nbsp;</span>
        <button
          type="button"
          class="modal-subtitle-link"
          (click)="onRecoveryLinkClick()">
          {{ 'tenant.passwordManagement.instructionClic' | translate }}.
        </button>
      </p>

      <mat-form-field appearance="outline" class="change-password-mat-field" floatLabel="auto">
        <mat-label>{{ 'modal.newPassword' | translate }}</mat-label>
        <input
          matInput
          [type]="hideNew ? 'password' : 'text'"
          formControlName="newPassword"
          autocomplete="new-password" />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideNew = !hideNew"
          [attr.aria-label]="'authentication.password' | translate"
          [disableRipple]="true">
          <mat-icon fontSet="material-icons-outlined">{{ hideNew ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
          {{ 'modal.required' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">
          {{ 'toastrMessage.warning.passwordMinLength' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="change-password-mat-field" floatLabel="auto">
        <mat-label>{{ 'modal.confirmPassword' | translate }}</mat-label>
        <input
          matInput
          [type]="hideConfirm ? 'password' : 'text'"
          formControlName="confirmPassword"
          autocomplete="new-password" />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideConfirm = !hideConfirm"
          [attr.aria-label]="'authentication.password' | translate"
          [disableRipple]="true">
          <mat-icon fontSet="material-icons-outlined">{{ hideConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
          {{ 'modal.required' | translate }}
        </mat-error>
      </mat-form-field>

      <p class="password-mismatch-hint c_500" *ngIf="passwordMismatch && form.dirty">
        {{ 'tenant.passwordManagement.errors.passwordMismatch' | translate }}
      </p>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [iconPosition]="false"
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [iconPosition]="false"
      [disabled]="saveDisabled"
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>
